export const rightArrow = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 68 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.8462 21.6011L46.9582 22.9934L45.5659 40.1056"
      stroke="white"
      strokeWidth="3.00001"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0464 45.0063L46.6994 23.2136"
      stroke="white"
      strokeWidth="3.00001"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
